import { useEffect, useState } from 'react';
import { fetchPublicSettings } from './publicSettingsCache';
import { normalizePricing } from '../config/pricing';

// Tarifa vigente de la consulta, tal como la define el backend. Comparte la
// petición cacheada de /settings/public con useDoctorRegistrationOpen.
// Mientras carga o si falla, pricing es null: la interfaz debe mostrar un
// estado neutro y nunca un valor inventado.
export default function usePricing() {
  const [state, setState] = useState({ pricing: null, loading: true });

  useEffect(() => {
    let alive = true;
    fetchPublicSettings().then((s) => {
      if (alive) setState({ pricing: normalizePricing(s?.pricing), loading: false });
    });
    return () => { alive = false; };
  }, []);

  return state;
}
